import styled from 'styled-components';

export const PlanoImagem = styled.div`
  display: flex;
  position: relative;

  border-radius: ${({ theme }) => theme.radius['4']}px;

  width: 300px;
  height: 160px;
`;
